import { BrowserRouter, Routes, Route, Link, Navigate, useNavigate } from "react-router-dom";

import { useEffect, useState } from "react";
import Header from "./pages/Header";
import Footer from "./pages/Footer";
import Register from "./pages/Register";
import MatchResult from "./pages/MatchResult";
import Questionnaire from "./pages/Questionnaire";
import ResultPage from "./pages/ResultPage";
import Profile from "./pages/Profile";
import ChatPage from "./pages/ChatPage";
import ChatListPage from "./pages/ChatListPage";
import DiscoverPage from "./pages/DiscoverPage";
import CityLandingPage from "./pages/CityLandingPage";
import CityIndexPage from "./pages/CityIndexPage";
import BookClubPage from "./pages/BookClubPage";
import CityBookClubApplyPage from "./pages/CityBookClubApplyPage";
import CoReadCenterPage from "./pages/CoReadCenterPage";
import { GrowthArticlePage, GrowthCategoryPage, GrowthHomePage } from "./pages/GrowthPages";
import ReadingCheckinPage from "./pages/ReadingCheckinPage";
import EventsPage, { OfflineEventCard } from "./pages/EventsPage";
import EventDetailPage from "./pages/EventDetailPage";
import CoursesPage from "./pages/CoursesPage";
import EbookCenter from "./pages/EbookCenter";
import EbookDetail from "./pages/EbookDetail";
import MyEbookDownloads from "./pages/MyEbookDownloads";
import MemberMomentsPage from "./pages/MemberMomentsPage";
import TopicLandingPage from "./pages/TopicLandingPage";
import TopicIndexPage from "./pages/TopicIndexPage";
import Login from "./pages/Login";
import WeChatCallbackPage from "./pages/WeChatCallbackPage";
import ForgotPassword from "./pages/ForgotPassword";
import ProfileSetup from "./pages/ProfileSetup";
import AccountSecurityPage from "./pages/AccountSecurityPage";
import UserDetail from "./pages/UserDetail";
import InboxPage from "./pages/InboxPage";
import FriendsPage from "./pages/FriendsPage";
import CenterLayout from "./pages/CenterLayout";
import CenterHome from "./pages/CenterHome";
import ProfileViewsPage from "./pages/ProfileViewsPage";
import PreviewPage from "./pages/PreviewPage";
import AlbumsPage from "./pages/AlbumsPage";
import VerifyPage from "./pages/VerifyPage";
import VerificationCenterPage from "./pages/VerificationCenterPage";
import VerificationCallbackPage from "./pages/VerificationCallbackPage";
import ConsultantRegister from "./pages/consultant/RegisterConsultants";

import ConsultantProfileSetup from "./pages/consultant/ConsultantProfileSetup";

import ConsultantLayout from "./pages/consultant/ConsultantLayout";
import ConsultantDashboard from "./pages/consultant/ConsultantDashboard";
import Orders from "./pages/consultant/Orders";
import ConsultantProfile from "./pages/consultant/ConsultantProfile";
import Income from "./pages/consultant/Income";
import Schedule from "./pages/consultant/Schedule";
import ConsultantDetail from "./pages/consultant/ConsultantDetail";
import ConsultantDetail2 from "./pages/consultant/ConsultantDetail2";
import ConsultantSchedule from "./pages/consultant/ConsultantSchedule";
import ConsultantList from "./pages/consultant/ConsultantList";
import ConsultantChat from "./pages/consultant/ConsultantChat"
import ConsultantClients from "./pages/consultant/ConsultantClients";

import AdminComingSoon from "./pages/admin/AdminComingSoon";
import AdminConsultants from "./pages/admin/AdminConsultants";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminLayout from "./pages/admin/AdminLayout";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminUsers from "./pages/admin/AdminUsers";
import AdminUserDetail from "./pages/admin/AdminUserDetail";
import AdminConsultantDetail from "./pages/admin/AdminConsultantDetail";
import AdminCitySeo from "./pages/admin/AdminCitySeo";
import AdminPlatformSettings from "./pages/admin/AdminPlatformSettings";
import AdminQuestionnaire from "./pages/admin/AdminQuestionnaire";
import AdminBookClub from "./pages/admin/AdminBookClub";
import AdminCityBookClubApply from "./pages/admin/AdminCityBookClubApply";
import AdminCoRead from "./pages/admin/AdminCoRead";
import AdminGrowth from "./pages/admin/AdminGrowth";
import AdminSeoLog from "./pages/admin/AdminSeoLog";
import AdminEvents from "./pages/admin/AdminEvents";
import AdminVideoCourses from "./pages/admin/AdminVideoCourses";
import AdminEbooks from "./pages/admin/AdminEbooks";
import AdminMemberMoments from "./pages/admin/AdminMemberMoments";
import AdminAnalytics from "./pages/admin/AdminAnalytics";
import AdminShop from "./pages/admin/AdminShop";
import AdminSecondhand from "./pages/admin/AdminSecondhand";
import AdminPlanet from "./pages/admin/AdminPlanet";
import PlanetLayout from "./pages/planet/PlanetLayout";
import PlanetHomePage from "./pages/planet/PlanetHomePage";
import PlanetSinglesMapPage from "./pages/planet/PlanetSinglesMapPage";
import PlanetBottlesPage from "./pages/planet/PlanetBottlesPage";
import PlanetBottleCreatePage from "./pages/planet/PlanetBottleCreatePage";
import PlanetBottleDetailPage from "./pages/planet/PlanetBottleDetailPage";
import PlanetEventsMapPage from "./pages/planet/PlanetEventsMapPage";
import PlanetPrivacyPage from "./pages/planet/PlanetPrivacyPage";
import SecondhandListPage from "./pages/secondhand/SecondhandListPage";
import SecondhandDetailPage from "./pages/secondhand/SecondhandDetailPage";
import SecondhandNewPage from "./pages/secondhand/SecondhandNewPage";
import SecondhandMinePage from "./pages/secondhand/SecondhandMinePage";
import AdminSystemMessages from "./pages/admin/AdminSystemMessages";
import ShopHomePage from "./pages/shop/ShopHomePage";
import ShopCategoryPage from "./pages/shop/ShopCategoryPage";
import ShopProductPage from "./pages/shop/ShopProductPage";
import ShopCheckoutPage from "./pages/shop/ShopCheckoutPage";
import ShopOrdersPage from "./pages/shop/ShopOrdersPage";
import ShopOrderDetailPage from "./pages/shop/ShopOrderDetailPage";
import SystemMessagesPage from "./pages/SystemMessagesPage";
import AiConsultantPage from "./pages/AiConsultantPage";
import AiMatchPage from "./pages/AiMatchPage";
import AiMemoryPage from "./pages/AiMemoryPage";
import AiGrowthPage from "./pages/AiGrowthPage";
import AiLoveAssistantPage from "./pages/AiLoveAssistantPage";
import LoveMapPage, { AiLoveCardRedirect } from "./pages/LoveMapPage";
import LoveMapCouplePage from "./pages/LoveMapCouplePage";
import AiMarriagePage from "./pages/AiMarriagePage";
import AiPersonalityPage from "./pages/AiPersonalityPage";
import AiTwinPage from "./pages/AiTwinPage";
import AiSimulationPage from "./pages/AiSimulationPage";
import RelationshipGrowthPage from "./pages/RelationshipGrowthPage";
import BehaviorProfilePage from "./pages/BehaviorProfilePage";
import RelationshipTrainPage from "./pages/RelationshipTrainPage";
import RelationshipMemoryPage from "./pages/RelationshipMemoryPage";
import RelationshipMapPage from "./pages/RelationshipMapPage";
import AiHubPage from "./pages/AiHubPage";
import MarriageLayout from "./pages/marriage/MarriageLayout";
import MarriageHome from "./pages/marriage/MarriageHome";
import MarriagePolicy from "./pages/marriage/MarriagePolicy";
import MarriagePlaces from "./pages/marriage/MarriagePlaces";
import MarriageAssistant from "./pages/marriage/MarriageAssistant";
import MarriageSimulation from "./pages/marriage/MarriageSimulation";
import MarriageCertificate from "./pages/marriage/MarriageCertificate";
import MarriageMarriedLife from "./pages/marriage/MarriageMarriedLife";
import MarriageQuestions from "./pages/marriage/MarriageQuestions";
import MarriageDate from "./pages/marriage/MarriageDate";
import LoveTravel from "./pages/travel/LoveTravel";
import RomanticMap from "./pages/travel/RomanticMap";
import ImpulseSimulator from "./pages/travel/ImpulseSimulator";
import WeddingServices from "./pages/wedding/WeddingServices";
import AdminMarriagePlaces from "./pages/admin/AdminMarriagePlaces";
import SiteAnalyticsTracker from "./components/SiteAnalyticsTracker";
import VoiceReminderFab from "./components/VoiceReminderFab";
import ReminderGlobalWatcher from "./components/ReminderGlobalWatcher";
import { apiFetch, apiJson, assetUrl } from "./utils/api";
import { formatCityLabel } from "./utils/resolveRegion";
import VerificationBadges from "./components/VerificationBadges";
import regions from "./pages/chinaRegions.json";
import { MARITAL_STATUS_OPTIONS, isMarriedUser } from "./constants/maritalStatus";
import { getOppositeGender, getOppositeGenderLabel } from "./constants/gender";
import useSeo from "./hooks/useSeo";
import { SEO_PAGES } from "./constants/seo";
import { TOPIC_SEO_LIST } from "./constants/topicSeo";
import {
  CONSULTANT_SKILL_OPTIONS,
  fetchConsultants,
  getConsultantImageUrl,
} from "./utils/consultants";
function Home() {
  const navigate = useNavigate();
  useSeo(SEO_PAGES.home);

  const [currentUserId, setCurrentUserId] = useState(localStorage.getItem("user_id"));
  const [myAvatar, setMyAvatar] = useState("");
  const [myGender, setMyGender] = useState("");
  const [hasUnread, setHasUnread] = useState(false);
  const [hotCities, setHotCities] = useState([]);
  const [offlineEvents, setOfflineEvents] = useState([]);
  const [offlineEventsLoading, setOfflineEventsLoading] = useState(false);
  const [province, setProvince] = useState("");
const [city, setCity] = useState("");
const [district, setDistrict] = useState("");
const provinces = regions.map(p => ({
  name: p.name,
  code: p.code,
}));

const selectedProvince = regions.find(p => p.name === province);
const cities = selectedProvince?.children || [];


const selectedCity = cities.find(c => c.name === city);

const districts = selectedCity?.children || [];


  useEffect(() => {
    const userId = localStorage.getItem("user_id");
    setCurrentUserId(userId);

    apiFetch("/api/public/city-seo?tier=1&page_size=12")
      .then((res) => res.json())
      .then((data) => setHotCities(data.items || []))
      .catch(() => setHotCities([]));

    setOfflineEventsLoading(true);
    apiFetch("/api/public/events?limit=3")
      .then((res) => res.json())
      .then((data) => setOfflineEvents(data.items || []))
      .catch(() => setOfflineEvents([]))
      .finally(() => setOfflineEventsLoading(false));

    if (!userId) return;

    const loadProfile = async () => {
      try {
        const res = await apiFetch(`/api/profile/${userId}`);
        const data = await res.json();

        if (res.ok) {
          setMyAvatar(data.avatar ? `${data.avatar}` : "");
          setMyGender(data.gender || "");
          if (data.marital_status) {
            localStorage.setItem("marital_status", data.marital_status);
          }
        }
      } catch (err) {
        console.error("加载头像失败:", err);
      }
    };

    const loadUnread = async () => {
      try {
        const res = await apiFetch(
          `/api/unread-count?current_user_id=${userId}`
        );
        const data = await res.json();

        if (res.ok) {
          setHasUnread((data.unread_count || 0) > 0);
        }
      } catch (err) {
        console.error("获取未读消息失败:", err);
      }
    };

    loadProfile();
    loadUnread();
  }, []);

  const [singleType, setSingleType] = useState("recommended");
  const [singleItems, setSingleItems] = useState([]);
  const [singleLoading, setSingleLoading] = useState(false);

  const [consultantItems, setConsultantItems] = useState([]);
  const [consultantLoading, setConsultantLoading] = useState(false);
  const [consultantKeyword, setConsultantKeyword] = useState("");
  const [appliedConsultantKeyword, setAppliedConsultantKeyword] = useState("");
  const [consultantSkill, setConsultantSkill] = useState("");

  const [searchGender, setSearchGender] = useState("");
  const [searchMarriage, setSearchMarriage] = useState("");
  const [searchAgeMin, setSearchAgeMin] = useState("");
  const [searchAgeMax, setSearchAgeMax] = useState("");

  const getImageUrl = (url) => assetUrl(url);

  const preferredGender = getOppositeGender(myGender);
  const isMarried = isMarriedUser(
    localStorage.getItem("marital_status") || ""
  );

  useEffect(() => {
    setSingleLoading(true);
    const params = new URLSearchParams();
    params.append("category", singleType);
    params.append("limit", "6");
    if (currentUserId) params.append("current_user_id", currentUserId);
    if (province) params.append("province", province);
    if (city) params.append("city", city);
    if (district) params.append("district", district);
    if (!currentUserId && searchGender) params.append("gender", searchGender);
    if (searchMarriage) params.append("marital_status", searchMarriage);
    if (searchAgeMin) params.append("age_min", searchAgeMin);
    if (searchAgeMax) params.append("age_max", searchAgeMax);

    apiJson(`/api/public/users?${params.toString()}`)
      .then(({ data }) => setSingleItems(Array.isArray(data) ? data : []))
      .catch((err) => {
        console.error("单身推荐加载失败:", err.message || err);
        setSingleItems([]);
      })
      .finally(() => setSingleLoading(false));
  }, [
    singleType,
    currentUserId,
    searchGender,
    searchMarriage,
    searchAgeMin,
    searchAgeMax,
    province,
    city,
    district,
  ]);

  useEffect(() => {
    setConsultantLoading(true);
    fetchConsultants({
      keyword: appliedConsultantKeyword,
      skill: consultantSkill,
      city: city || "",
      limit: 6,
    })
      .then(setConsultantItems)
      .catch((err) => {
        console.error("咨询师推荐加载失败:", err);
        setConsultantItems([]);
      })
      .finally(() => setConsultantLoading(false));
  }, [appliedConsultantKeyword, consultantSkill, city]);

  const singleTabs = [
    { key: "recommended", label: "推荐" },
    { key: "verified", label: "认证" },
    { key: "member", label: "会员" },
  ];

  const handleConsultantSearch = (e) => {
    e?.preventDefault();
    setAppliedConsultantKeyword(consultantKeyword.trim());
  };

  const goConsultantsPage = () => {
    const params = new URLSearchParams();
    if (appliedConsultantKeyword) params.set("keyword", appliedConsultantKeyword);
    if (consultantSkill) params.set("skill", consultantSkill);
    const query = params.toString();
    navigate(query ? `/consultants?${query}` : "/consultants");
  };


  return (
    <div className="min-h-screen bg-gradient-to-br from-rose-50 via-pink-50 to-fuchsia-50 text-gray-800">

         <Header/>

      <section className="text-center pt-8 pb-4 px-6">
        <h2 className="text-3xl md:text-4xl font-extrabold mb-5 leading-snug">
          从相识到婚姻
          <span className="text-pink-600">，全程陪伴</span>
        </h2>
        <div className="flex justify-center flex-wrap gap-4">
          {!(currentUserId && isMarried) && (
            <Link
              to="/love-map"
              className="px-9 py-3 bg-rose-600 text-white rounded-full shadow-lg shadow-rose-200 hover:bg-rose-700 transition font-semibold"
            >
              爱情地图
            </Link>
          )}
          <Link
            to={
              currentUserId && isMarried ? "/ai/marriage" : "/ai/consultant"
            }
            className="px-9 py-3 border border-rose-400 text-rose-600 rounded-full hover:bg-white transition"
          >
            {currentUserId && isMarried ? "婚姻顾问" : "AI咨询师"}
          </Link>
        </div>
      </section>

      <section className="pt-1 pb-8 bg-white">
        <h3 className="text-xl text-center font-bold mb-1.5">知自己 · 会沟通 · 助成长</h3>
        <p className="text-center text-gray-500 text-sm mb-4 max-w-xl mx-auto">
          认识自己、学着沟通、在关系里慢慢成长
        </p>
        <div className="max-w-6xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-3 px-4">
          {[
            {
              title: "AI关系地图",
              desc: "爱情地图 · 关系地图 · 关系模拟",
              to: "/ai/hub/relationship",
              color: "from-pink-500 to-rose-500",
              icon: "🗺️",
            },
            {
              title: "数字人格",
              desc: "AI人格 · 数字分身",
              to: "/ai/hub/persona",
              color: "from-rose-500 to-orange-400",
              icon: "🧭",
            },
            {
              title: "AI婚恋顾问",
              desc: "恋爱助手 · 婚姻顾问 · 咨询师",
              to: "/ai/hub/advisor",
              color: "from-fuchsia-500 to-pink-500",
              icon: "💬",
            },
            {
              title: "领证中心",
              desc: "政策 · 地点 · 婚前准备",
              to: "/marriage",
              color: "from-red-500 to-rose-600",
              icon: "💍",
            },
          ].map((item) => (
            <Link
              key={item.title}
              to={item.to}
              className={`rounded-2xl text-white bg-gradient-to-r ${item.color} shadow-md hover:scale-[1.02] transition block px-3 py-4 text-center`}
            >
              <div className="text-2xl mb-1">{item.icon}</div>
              <h4 className="font-bold text-sm md:text-base">{item.title}</h4>
              <p className="text-[10px] md:text-[11px] text-white/85 mt-0.5 leading-snug">{item.desc}</p>
            </Link>
          ))}
        </div>
      </section>

      <section className="py-14 px-6">
        <h3 className="text-3xl text-center font-bold mb-2">单身推荐</h3>
        <p className="text-center text-gray-500 text-sm mb-8">
          {currentUserId && preferredGender
            ? `已登录 · 为您推荐${getOppositeGenderLabel(myGender)}`
            : "未登录也可浏览 · 注册后可查看完整资料与 AI 匹配"}
        </p>

        <div className="max-w-5xl mx-auto mb-8">
          <div className="bg-white rounded-2xl shadow p-4 flex flex-wrap gap-3 items-center">
            <select
              value={province}
              onChange={(e) => {
                setProvince(e.target.value);
                setCity("");
                setDistrict("");
              }}
              className="border rounded-xl px-4 py-2"
            >
              <option value="">省份</option>
              {provinces.map((p) => (
                <option key={p.code} value={p.name}>
                  {p.name}
                </option>
              ))}
            </select>

            <select
              value={city}
              onChange={(e) => {
                setCity(e.target.value);
                setDistrict("");
              }}
              className="border rounded-xl px-4 py-2"
            >
              <option value="">城市</option>
              {cities.map((c) => (
                <option key={c.code} value={c.name}>
                  {c.name}
                </option>
              ))}
            </select>

            <select
              value={district}
              onChange={(e) => setDistrict(e.target.value)}
              className="border rounded-xl px-4 py-2"
            >
              <option value="">区县</option>
              {districts.map((d) => (
                <option key={d.code} value={d.name}>
                  {d.name}
                </option>
              ))}
            </select>

            {currentUserId && preferredGender ? (
              <div
                className="border rounded-xl px-4 py-2 bg-gray-50 text-gray-600 text-sm"
                title="根据您的性别自动推荐异性"
              >
                {getOppositeGenderLabel(myGender)}
              </div>
            ) : (
              <select
                value={searchGender}
                onChange={(e) => setSearchGender(e.target.value)}
                className="border rounded-xl px-4 py-2"
              >
                <option value="">性别</option>
                <option value="男">男</option>
                <option value="女">女</option>
              </select>
            )}

            <select
              value={searchMarriage}
              onChange={(e) => setSearchMarriage(e.target.value)}
              className="border rounded-xl px-4 py-2"
            >
              <option value="">婚姻状况</option>
              {MARITAL_STATUS_OPTIONS.filter((item) => item.value !== "已婚").map(
                (item) => (
                  <option key={item.value} value={item.value}>
                    {item.label}
                  </option>
                )
              )}
            </select>

            <input
              type="number"
              placeholder="最小年龄"
              value={searchAgeMin}
              onChange={(e) => setSearchAgeMin(e.target.value)}
              className="border rounded-xl px-4 py-2 w-28"
            />

            <input
              type="number"
              placeholder="最大年龄"
              value={searchAgeMax}
              onChange={(e) => setSearchAgeMax(e.target.value)}
              className="border rounded-xl px-4 py-2 w-28"
            />
          </div>
        </div>

        <div className="max-w-6xl mx-auto">
          <div className="flex justify-center gap-3 mb-8">
            {singleTabs.map((tab) => (
              <button
                key={tab.key}
                type="button"
                onClick={() => setSingleType(tab.key)}
                className={`px-5 py-2 rounded-full text-sm border transition ${
                  singleType === tab.key
                    ? "bg-pink-50 border-pink-400 text-pink-600"
                    : "bg-white border-gray-200 text-gray-500 hover:border-pink-300"
                }`}
              >
                {tab.label}
              </button>
            ))}
          </div>

          {singleLoading ? (
            <div className="bg-white p-10 rounded-xl shadow text-center text-gray-400">
              正在加载推荐列表...
            </div>
          ) : singleItems.length === 0 ? (
            <div className="bg-white p-10 rounded-xl shadow text-center text-gray-400">
              暂无推荐会员
            </div>
          ) : (
            <div className="grid md:grid-cols-3 gap-6">
              {singleItems.map((item) => (
                <Link
                  key={item.id}
                  to={`/user/${item.id}`}
                  className="bg-white p-6 rounded-xl shadow hover:-translate-y-1 transition block"
                >
                  <div className="flex items-center gap-4 mb-4">
                    {getImageUrl(item.avatar) ? (
                      <img
                        src={getImageUrl(item.avatar)}
                        alt={item.name || "头像"}
                        className="w-14 h-14 rounded-full object-cover"
                      />
                    ) : (
                      <div className="w-14 h-14 rounded-full bg-pink-100 text-pink-600 flex items-center justify-center font-bold">
                        {item.name?.slice(0, 1) || "未"}
                      </div>
                    )}
                    <div>
                      <h4 className="font-bold text-lg">{item.name || "未填写"}</h4>
                      <p className="text-sm text-gray-500">
                        {formatCityLabel(item.province, item.city, item.district, "城市未填写")} ·{" "}
                        {item.age ? `${item.age}岁` : "年龄未填写"}
                      </p>
                    </div>
                  </div>
                  <p className="text-sm text-gray-600 line-clamp-2">
                    {item.bio || item.job || "这个用户还没有填写介绍"}
                  </p>
                  <div className="mt-4 flex gap-2 text-xs flex-wrap items-center">
                    <VerificationBadges
                      verification={item.verification}
                      userId={item.id}
                      userName={item.name}
                      variant="compact"
                    />
                    {item.is_member ? (
                      <span className="px-3 py-1 rounded-full bg-amber-50 text-amber-600">
                        会员
                      </span>
                    ) : null}
                  </div>
                </Link>
              ))}
            </div>
          )}

          <div className="text-center mt-8">
            <Link
              to="/discover"
              className="inline-block px-8 py-3 rounded-full border border-pink-400 text-pink-600 hover:bg-pink-50"
            >
              查看更多会员 →
            </Link>
          </div>
        </div>
      </section>

      <section className="py-16 px-6 bg-gradient-to-b from-rose-50 to-white">
        <h3 className="text-3xl text-center font-bold mb-2">线下活动</h3>
        <p className="text-center text-gray-500 text-sm mb-8">
          相亲联谊 · 情感沙龙 · 成长工作坊 · 把线上缘分带到线下
        </p>
        <div className="max-w-6xl mx-auto">
          {offlineEventsLoading ? (
            <div className="bg-white p-10 rounded-xl shadow text-center text-gray-400">
              正在加载活动...
            </div>
          ) : offlineEvents.length === 0 ? (
            <div className="bg-white p-10 rounded-2xl shadow text-center">
              <p className="text-gray-400 mb-4">近期活动筹备中，欢迎关注交友活动</p>
              <Link to="/events" className="text-pink-600 hover:underline text-sm">
                进入交友活动 →
              </Link>
            </div>
          ) : (
            <div className="grid md:grid-cols-3 gap-6">
              {offlineEvents.map((item) => (
                <OfflineEventCard key={item.id} item={item} />
              ))}
            </div>
          )}
          <div className="text-center mt-8">
            <Link
              to="/events"
              className="inline-block px-8 py-3 rounded-full border border-pink-400 text-pink-600 hover:bg-pink-50"
            >
              查看全部活动 →
            </Link>
          </div>
        </div>
      </section>

      <section className="py-20 px-6 bg-white">
        <h3 className="text-3xl text-center font-bold mb-2">咨询师推荐</h3>
        <p className="text-center text-gray-500 text-sm mb-8">
          认证咨询师优先 · 在线接单优先 · 资深咨询师优先
        </p>

        <div className="max-w-5xl mx-auto mb-8">
          <form
            onSubmit={handleConsultantSearch}
            className="bg-gray-50 rounded-2xl shadow p-4 flex flex-wrap gap-3 items-center"
          >
            <input
              value={consultantKeyword}
              onChange={(e) => setConsultantKeyword(e.target.value)}
              placeholder="搜索咨询师、城市、擅长方向"
              className="flex-1 min-w-[200px] border rounded-xl px-4 py-2"
            />
            <select
              value={consultantSkill}
              onChange={(e) => setConsultantSkill(e.target.value)}
              className="border rounded-xl px-4 py-2 bg-white"
            >
              {CONSULTANT_SKILL_OPTIONS.map((item) => (
                <option key={item.value || "all"} value={item.value}>
                  {item.label}
                </option>
              ))}
            </select>
            <button
              type="submit"
              className="px-6 py-2 rounded-xl bg-blue-500 text-white font-medium hover:bg-blue-600"
            >
              搜索
            </button>
          </form>
        </div>

        <div className="max-w-6xl mx-auto">
          {consultantLoading ? (
            <div className="bg-gray-50 p-10 rounded-xl shadow text-center text-gray-400">
              正在加载咨询师...
            </div>
          ) : consultantItems.length === 0 ? (
            <div className="bg-gray-50 p-10 rounded-xl shadow text-center text-gray-400">
              暂无匹配的咨询师
            </div>
          ) : (
            <div className="grid md:grid-cols-3 gap-6">
              {consultantItems.map((item) => (
                <Link
                  key={item.id}
                  to={`/consultants2/${item.id}`}
                  className="bg-gray-50 p-6 rounded-xl shadow hover:-translate-y-1 transition block border border-transparent hover:border-blue-100"
                >
                  <div className="flex items-center gap-4 mb-4">
                    {getConsultantImageUrl(item.avatar) ? (
                      <img
                        src={getConsultantImageUrl(item.avatar)}
                        alt={item.name || "头像"}
                        className="w-14 h-14 rounded-full object-cover"
                      />
                    ) : (
                      <div className="w-14 h-14 rounded-full bg-blue-100 text-blue-600 flex items-center justify-center font-bold">
                        {item.name?.slice(0, 1) || "咨"}
                      </div>
                    )}
                    <div>
                      <h4 className="font-bold text-lg">{item.name || "未填写"}</h4>
                      <p className="text-sm text-gray-500">
                        {formatCityLabel(item.province, item.city, item.district, "城市未填写")}
                        {item.experience_years
                          ? ` · ${item.experience_years}年经验`
                          : ""}
                      </p>
                    </div>
                  </div>
                  <p className="text-sm text-gray-600 line-clamp-2">
                    {item.intro || item.specialties || "咨询师资料完善中"}
                  </p>
                  <div className="mt-4 flex gap-2 text-xs flex-wrap">
                    {item.is_verified ? (
                      <span className="px-3 py-1 rounded-full bg-blue-50 text-blue-600">
                        已认证
                      </span>
                    ) : (
                      <span className="px-3 py-1 rounded-full bg-gray-100 text-gray-500">
                        未认证
                      </span>
                    )}
                    {item.experience_years >= 5 ? (
                      <span className="px-3 py-1 rounded-full bg-amber-50 text-amber-600">
                        资深
                      </span>
                    ) : null}
                    {item.is_online ? (
                      <span className="px-3 py-1 rounded-full bg-green-50 text-green-600">
                        在线
                      </span>
                    ) : null}
                  </div>
                </Link>
              ))}
            </div>
          )}

          <div className="text-center mt-8">
            <button
              type="button"
              onClick={goConsultantsPage}
              className="inline-block px-8 py-3 rounded-full border border-blue-400 text-blue-600 hover:bg-blue-50"
            >
              查看全部咨询师 →
            </button>
          </div>
        </div>
      </section>

      <section className="py-16 px-6 bg-white">
        <h3 className="text-3xl text-center font-bold mb-3">关系成长</h3>
        <p className="text-center text-gray-500 text-sm mb-6 max-w-xl mx-auto">
          经过人工审核后公开的文章，讨论倾听、冲突、边界和信任。
        </p>
        <div className="text-center">
          <Link
            to="/growth"
            className="inline-block px-8 py-3 rounded-full border border-pink-400 text-pink-600 hover:bg-pink-50"
          >
            阅读关系成长文章
          </Link>
        </div>
      </section>

      <section className="py-20 px-6 bg-pink-50">
  <h3 className="text-3xl text-center font-bold mb-10">成功案例</h3>
  <div className="max-w-5xl mx-auto bg-white p-10 rounded-xl shadow text-center text-gray-400">
    成功案例内容暂未开放
  </div>
</section>


      <section className="text-center py-20 bg-gradient-to-r from-pink-400 to-rose-400 text-white">
        <h2 className="text-4xl font-bold mb-4">找对象 · 修婚姻 · 提升关系</h2>
        <p className="mb-6">AI测评 + 智能匹配 + 专业咨询师</p>
        <div className="flex justify-center gap-4">
          <Link to="/register" className="bg-white text-pink-500 px-8 py-3 rounded-full font-semibold">
            免费开始
          </Link>
          <Link to="/discover" className="border border-white px-8 py-3 rounded-full">
            寻找对象
          </Link>
        </div>
      </section>

      <footer className="text-center py-8 text-gray-400 text-sm space-y-4">
        <div className="max-w-4xl mx-auto px-4 space-y-4">
          <div>
            <p className="text-xs text-gray-400 mb-2">热门专题</p>
            <div className="flex flex-wrap justify-center gap-x-3 gap-y-1">
              {TOPIC_SEO_LIST.map((topic) => (
                <Link
                  key={topic.slug}
                  to={`/topic/${topic.slug}`}
                  className="text-gray-500 hover:text-pink-500 transition"
                >
                  {topic.badge}
                </Link>
              ))}
              <Link to="/topic" className="text-pink-500 hover:underline">
                全部专题
              </Link>
            </div>
          </div>
          <div>
            <p className="text-xs text-gray-400 mb-2">热门城市</p>
            <div className="flex flex-wrap justify-center gap-x-3 gap-y-1">
              {hotCities.map((city) => (
                <Link
                  key={city.slug}
                  to={`/city/${city.slug}`}
                  className="text-gray-500 hover:text-pink-500 transition"
                >
                  {city.short_name}婚恋交友
                </Link>
              ))}
              <Link to="/city" className="text-pink-500 hover:underline">
                更多城市
              </Link>
            </div>
          </div>
        </div>
        <p>© 2026 AI婚恋平台</p>
      </footer>

      <VoiceReminderFab />
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <SiteAnalyticsTracker />
      <ReminderGlobalWatcher />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/register" element={<Register />} />
        <Route path="/questionnaire" element={<Questionnaire />} />
        <Route path="/match" element={<MatchResult />} />
        <Route path="/discover" element={<DiscoverPage />} />
        <Route path="/city" element={<CityIndexPage />} />
        <Route path="/city/:citySlug" element={<CityLandingPage />} />
        <Route path="/topic" element={<TopicIndexPage />} />
        <Route path="/topic/:topicSlug" element={<TopicLandingPage />} />
        <Route path="/book-club" element={<BookClubPage />} />
        <Route path="/book-club/city-apply" element={<CityBookClubApplyPage />} />
        <Route path="/book-club/ai-center" element={<CoReadCenterPage />} />
        <Route path="/growth" element={<GrowthHomePage />} />
        <Route path="/growth/category/:slug" element={<GrowthCategoryPage />} />
        <Route path="/growth/:slug" element={<GrowthArticlePage />} />
        <Route path="/reading/checkin" element={<ReadingCheckinPage />} />
        <Route path="/ebooks" element={<EbookCenter />} />
        <Route path="/ebooks/:ebookId" element={<EbookDetail />} />
        <Route path="/events" element={<EventsPage />} />
        <Route path="/events/:eventId" element={<EventDetailPage />} />
        <Route path="/planet" element={<PlanetLayout />}>
          <Route index element={<PlanetHomePage />} />
          <Route path="singles" element={<PlanetSinglesMapPage />} />
          <Route path="bottles" element={<PlanetBottlesPage />} />
          <Route path="bottles/create" element={<PlanetBottleCreatePage />} />
          <Route path="bottles/:id" element={<PlanetBottleDetailPage />} />
          <Route path="events" element={<PlanetEventsMapPage />} />
          <Route path="settings/privacy" element={<PlanetPrivacyPage />} />
        </Route>
        <Route path="/courses" element={<CoursesPage />} />
        <Route path="/shop" element={<ShopHomePage />} />
        <Route path="/shop/category/:slug" element={<ShopCategoryPage />} />
        <Route path="/shop/product/:slug" element={<ShopProductPage />} />
        <Route path="/shop/checkout" element={<ShopCheckoutPage />} />
        <Route path="/shop/orders" element={<ShopOrdersPage />} />
        <Route path="/shop/orders/:orderNo" element={<ShopOrderDetailPage />} />
        <Route path="/secondhand" element={<SecondhandListPage />} />
        <Route path="/secondhand/new" element={<SecondhandNewPage />} />
        <Route path="/secondhand/mine" element={<SecondhandMinePage />} />
        <Route path="/secondhand/:id" element={<SecondhandDetailPage />} />
        <Route path="/moments" element={<MemberMomentsPage />} />
        <Route path="/ai/consultant" element={<AiConsultantPage />} />
        <Route path="/ai/personality" element={<AiPersonalityPage />} />
        <Route path="/ai/twin" element={<AiTwinPage />} />
        <Route path="/ai/match" element={<AiMatchPage />} />
        <Route path="/ai/simulation" element={<AiSimulationPage />} />
        <Route path="/ai/relationship-growth" element={<RelationshipGrowthPage />} />
        <Route path="/ai/behavior-profile" element={<BehaviorProfilePage />} />
        <Route path="/ai/relationship-train" element={<RelationshipTrainPage />} />
        <Route path="/ai/relationship-memory" element={<RelationshipMemoryPage />} />
        <Route path="/ai/relationship-map" element={<RelationshipMapPage />} />
        <Route
          path="/ai/hub/relationship"
          element={<AiHubPage groupKey="relationship" />}
        />
        <Route path="/ai/hub/persona" element={<AiHubPage groupKey="persona" />} />
        <Route path="/ai/hub/advisor" element={<AiHubPage groupKey="advisor" />} />
        {/* 别名：避免重复收录，统一跳到咨询页陪聊 tab */}
        <Route
          path="/ai/companion"
          element={<Navigate to="/ai/consultant?tab=chat" replace />}
        />
        <Route path="/ai/growth" element={<AiGrowthPage />} />
        <Route path="/love-map" element={<LoveMapPage />} />
        <Route path="/love-map/couple" element={<LoveMapCouplePage />} />
        <Route path="/ai-love-card" element={<AiLoveCardRedirect />} />
        <Route path="/ai/love-assistant" element={<AiLoveAssistantPage />} />
        <Route path="/ai/marriage" element={<AiMarriagePage />} />
        <Route path="/marriage" element={<MarriageLayout />}>
          <Route index element={<MarriageHome />} />
          <Route path="policy" element={<MarriagePolicy />} />
          <Route path="places" element={<MarriagePlaces />} />
          <Route path="assistant" element={<MarriageAssistant />} />
          <Route path="simulation" element={<MarriageSimulation />} />
          <Route path="certificate/:code" element={<MarriageCertificate />} />
          <Route path="married-life" element={<MarriageMarriedLife />} />
          <Route path="questions" element={<MarriageQuestions />} />
          <Route path="date" element={<MarriageDate />} />
        </Route>
        <Route path="/travel" element={<MarriageLayout />}>
          <Route path="love" element={<LoveTravel />} />
          <Route path="romantic-map" element={<RomanticMap />} />
          <Route path="impulse" element={<ImpulseSimulator />} />
        </Route>
        <Route path="/wedding" element={<MarriageLayout />}>
          <Route index element={<WeddingServices />} />
        </Route>
        <Route path="/result" element={<ResultPage />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/chat" element={<ChatPage />} />
        <Route path="/chat-list" element={<ChatListPage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/login/wechat-callback" element={<WeChatCallbackPage />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/profile/setup" element={<ProfileSetup />} />
        <Route path="/user/:id" element={<UserDetail />} />
        <Route path="/inbox" element={<InboxPage />} />
        <Route path="/friends" element={<FriendsPage />} />
        <Route path="/consultants" element={<ConsultantList />} />
        <Route path="/consultants2/:id" element={<ConsultantDetail2 />} />

        <Route path="/consultant-chat/:consultantId" element={<ConsultantChat />} />

        <Route path="/registerConsultants" element={<ConsultantRegister />} />




        <Route path="/admin/login" element={<AdminLogin />} />
<Route path="/admin" element={<AdminLayout />}>
  <Route index element={<AdminDashboard />} />
  <Route path="users" element={<AdminUsers />} />
   <Route path="users/:userId" element={<AdminUserDetail />} />

 <Route
          path="consultants/:consultantId"
          element={<AdminConsultantDetail />}
        />
  <Route path="consultants" element={<AdminConsultants />} />
  <Route path="messages" element={<AdminSystemMessages />} />
  <Route
    path="organizations"
    element={<AdminComingSoon title="机构管理" />}
  />
  <Route path="site" element={<AdminCitySeo />} />
  <Route path="platform-settings" element={<AdminPlatformSettings />} />
  <Route path="questionnaire" element={<AdminQuestionnaire />} />
  <Route path="book-club" element={<AdminBookClub />} />
  <Route path="book-club-city-apply" element={<AdminCityBookClubApply />} />
  <Route path="co-read" element={<AdminCoRead />} />
  <Route path="growth" element={<AdminGrowth />} />
  <Route path="seo-log" element={<AdminSeoLog />} />
  <Route path="events" element={<AdminEvents />} />
  <Route path="courses" element={<AdminVideoCourses />} />
  <Route path="ebooks" element={<AdminEbooks />} />
  <Route path="moments" element={<AdminMemberMoments />} />
  <Route path="analytics" element={<AdminAnalytics />} />
  <Route path="marriage-places" element={<AdminMarriagePlaces />} />
  <Route path="shop" element={<AdminShop />} />
  <Route path="secondhand" element={<AdminSecondhand />} />
  <Route path="planet" element={<AdminPlanet />} />
</Route>



 <Route path="/center" element={<CenterLayout />}>
  <Route index element={<CenterHome />} />
  <Route path="views" element={<ProfileViewsPage />} />
  <Route path="preview" element={<PreviewPage />} />
  <Route path="profile" element={<ProfileSetup />} />
  <Route path="ai-memory" element={<AiMemoryPage />} />
  <Route
    path="security"
    element={
      <AccountSecurityPage role="user" theme="pink" storageKey="user_id" />
    }
  />
  <Route path="friends" element={<FriendsPage />} />
  <Route path="albums" element={<AlbumsPage />} />
  <Route path="inbox" element={<InboxPage />} />
  <Route
    path="messages"
    element={<SystemMessagesPage role="user" storageKey="user_id" theme="pink" />}
  />
  <Route path="verify" element={<VerificationCenterPage />} />
  <Route path="verify/callback" element={<VerificationCallbackPage />} />
  <Route path="verify/id" element={<VerifyPage />} />
  <Route path="ebook-downloads" element={<MyEbookDownloads />} />
</Route>




  <Route path="/consultant" element={<ConsultantLayout />}>
  <Route index element={<ConsultantDashboard />} />
  <Route path="orders" element={<Orders />} />
  <Route path="profile" element={<ConsultantProfile />} />
  <Route path="income" element={<Income />} />
    <Route path="clients" element={<ConsultantClients />} />
    <Route
      path="messages"
      element={
        <SystemMessagesPage
          role="consultant"
          storageKey="consultant_id"
          theme="blue"
        />
      }
    />




    <Route path="profile/setup" element ={<ConsultantProfileSetup/> }/>
    <Route
      path="security"
      element={
        <AccountSecurityPage
          role="consultant"
          theme="blue"
          storageKey="consultant_id"
        />
      }
    />
      <Route path="/consultant/:id" element={<ConsultantDetail />}/>
      <Route path="schedule" element={<ConsultantSchedule />} />

</Route>



      </Routes>
    </BrowserRouter>
  );
}
